export default function(pattern, str) {
  str = str.toLowerCase()
  pattern = pattern.replace(/\W/g, '').toLowerCase() // strip non alpha numeric
  pattern = pattern.split('').reduce(function(a, b) {
    return a + '.*' + b
  })
  return new RegExp(pattern).test(str)
}
